import { CurrentUser } from '@/types/user';

export type PermissionAction = 'read' | 'write' | 'delete';

export function hasPermission(
  currentUser: CurrentUser | null,
  action: PermissionAction
): boolean {
  if (!currentUser) {
    return false;
  }

  const { user_details } = currentUser;

  if (user_details.user_type === 'revenue_manager') {
    return true;
  }
  if (['admin', 'staff'].includes(user_details.user_type)) {
    return true;
  }

  if (user_details.user_type === 'revenue_staff') {
    const permissions = user_details?.revenue_staff_permissions || [];
    // console.log('permissions----->',permissions)
    if (!permissions || permissions.length === 0) {
      return false;
    }

    const permission = permissions[0];

    switch (action) {
      case 'read':
        return permission.can_read === 1;
      case 'write':
        return permission.can_write === 1;
      case 'delete':
        return permission.can_delete === 1;
      default:
        return false;
    }
  }

  return false;
}

export function canRead(currentUser: CurrentUser | null): boolean {
  return hasPermission(currentUser, 'read');
}

export function canWrite(currentUser: CurrentUser | null): boolean {
  return hasPermission(currentUser, 'write');
}

export function canDelete(currentUser: CurrentUser | null): boolean {
  return hasPermission(currentUser, 'delete');
}

export function isRevenueManager(currentUser: CurrentUser | null): boolean {
  return currentUser?.user_details.user_type === 'revenue_manager';
}

export function isRevenueStaff(currentUser: CurrentUser | null): boolean {
  return currentUser?.user_details.user_type === 'revenue_staff';
}

export function hasFullAccess(currentUser: CurrentUser | null): boolean {
  return isRevenueManager(currentUser);
}
